/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  Container,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@common-ui/ui";
import JsPDF from "jspdf";
import { WorkItem } from "../../../components/CollapsibleData/WorkItem";
import { getWorkItem } from "../../../services/WorkItems";
import {
  getAssetDetails,
  getCustomer,
  getOrgWorkEvent,
  getProcedure,
} from "../../../services";
import { getProcedureStatus } from "../../../services/procedureRuntime";
import { useDispatch } from "react-redux";
import { workItemsSlice } from "../../../reducers/workItemsReducer";
import { getOrg, getOrgProfileImage } from "../../../services/org";
import { InsertPhotoOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { Suspense } from "react";
import { AssetImage } from "../../Assets/AseetImage";
// import html2pdf from "jspdf-html2canvas";

const DetailReport = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);
  const [workItem, setWorkItem] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [workEvent, setWorkEvent] = useState(null);
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState([]);
  const [asset, setAsset] = useState(null);
  const [performingOrg, setPerformingOrg] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [orgImageFileType, setOrgImageFileType] = useState("");
  const onBeforeGetContentResolve = useRef(null);
  const reportRef = React.useRef(null);
  const componentRef = useRef();
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `report-${workItem?.id}`,
    copyStyles: true,
    // onBeforeGetContent: () => {
    //   if (isLoadingIframe) {
    //     setTimeout(() => handlePrint.onBeforePrint(), 5000);
    //     return;
    //   }
    //   // window.print();
    // },
    onBeforePrint: () => {
      if (isLoadingIframe) {
        setTimeout(() => handlePrint.onBeforePrint(), 10000);
        return;
      }
      window.print();
    },
    // onAfterPrint: () => {
    //   return;
    // },
    removeAfterPrint: true,
    // onBeforeGetContent: () => {
    //   return new Promise((resolve) => {
    //     console.log("here");
    //     setIsLoadingIframe(true);
    //     // onBeforeGetContentResolve.current = resolve;
    //   });
    // },
    // onAfterPrint: () => setIsLoadingIframe(false),
    // copyStyles: true,
    // print: async (printIframe) => {
    //   const document = printIframe.contentDocument;
    //   if (document) {
    //     const html = document.body;

    //     // console.log(html);
    //     // const exporter = new html2pdf(html);
    //     const report = new JsPDF("p", "pt", "letter");
    //     report
    //       .html(html, {
    //         // autoPaging: "text",
    //         html2canvas: {
    //           allowTaint: true,
    //           dpi: 300,
    //           letterRendering: true,
    //           logging: false,
    //           scale: 0.8,
    //         },
    //       })
    //       .then(() => {
    //         report.save("report.pdf");
    //       });
    //     // await exporter.getPdf(true);
    //   }
    // },
  });

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleMessage = async (event) => {
    // console.log("event-from-child🟢", event);
    const messageType = event.data?.messageType;
    const messageData = event.data?.message;
    // console.log("message", messageType, messageData);
    switch (messageType) {
      case `READY`:
        setTimeout(() => {
          setIsLoadingIframe(false);
          forceUpdate();
        }, 3000);
        break;
      case "HEIGHT":
        setTimeout(() => {
          setIsLoadingIframe(false);
          forceUpdate();
        }, 3000);
        break;
      default:
        break;
    }
  };

  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      // `react-to-print` will wait for this Promise to resolve before continuing
      // Load data
      onBeforeGetContentResolve.current = resolve;
      setDataLoaded(true); // When data is done loading
    });
  };

  let { workEventId, workItemId } = useParams();
  async function init() {
    try {
      const workItem = await getWorkItem(workEventId, workItemId);
      if (workItem) {
        const asset = await getAssetDetails(
          workItem.performing_org,
          workItem.asset
        );
        const performingOrg = await getOrg(workItem.performing_org);
        const workEvent = await getOrgWorkEvent(
          workItem.performing_org,
          workItem.work_event
        );
        let { logo } = performingOrg;

        if (logo && logo.length) {
          const imageType = logo
            .split("?")[0]
            .split("/")
            .slice(-1)[0]
            .split(".")[1];
          setOrgImageFileType(imageType);
        }

        try {
          if (!workEvent?.data?.for_customer) {
            const internalCUstomer = await getOrg(workEvent?.data?.for_org);
            setCustomer(internalCUstomer);
          } else {
            const externalCUstomer = await getOrgCustomer(
              params?.orgId,
              workEvent?.data?.for_customer
            );
            setCustomer(externalCUstomer);
          }
          console.log("customer", customer);
        } catch (error) {}

        setWorkEvent(workEvent?.data);

        setWorkEvent(workEvent);

        setPerformingOrg(performingOrg);
        setWorkItem(workItem);
        setAsset(asset);
        let procedure = await getProcedure(
          workItem?.service_option_procedure,
          workItem?.performing_org,
          workItem.service_type,
          workItem.service_option
        );
        let procedureStatus = await getProcedureStatus(
          workItem?.performing_org,
          workItem?.work_event,
          workItem.id
        );
        const row = {
          ...workItem,
          defaultProcedure: procedure,
          procedure: { ...procedure, status: procedureStatus },
        };
        dispatch(workItemsSlice.actions.setWorkItem(row));
        setRow(row);

        setIsLoading(false);
      }
    } catch (e) {
      setErrors([...errors, e]);
      setIsLoading(false);
      console.log(e);
    }
  }

  const generatePDF = () => {
    const report = new JsPDF("portrait", "px", [1940, 1940]);
    report
      .html(document.getElementById("report"), { width: "100%" })
      .then(() => {
        report.save("report.pdf");
      });
  };

  //console.log(id)
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    async function getImage() {
      try {
        if (workItem) {
          const response = await getOrgProfileImage(
            workItem?.performing_org,
            orgImageFileType
          );
          setImageUrl(response.data.url);
        }
      } catch (error) {
        setImageUrl("");
        console.log(error);
      }
    }
    if (orgImageFileType?.length) getImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgImageFileType, JSON.stringify(workItem?.performing_org)]);

  console.log("performingOrg", performingOrg);

  return isLoading ? (
    "Loading..."
  ) : (
    <div
      id="report"
      // ref={reportRef}
    >
      <Container>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            // onClick={generatePDF}
            // onClick={handlePrint}
            onClick={() => {
              if (isLoadingIframe) {
                setTimeout(() => handlePrint.onBeforePrint(), 10000);
                // return;
              }
              window.print();
            }}
            type="button"
          >
            Export PDF
          </Button>
        </Box>
      </Container>
      <Container ref={componentRef} sx={{ width: "100%" }}>
        <Stack direction="row" justifyContent="space-between" sx={{ pb: 2 }}>
          <Typography sx={{ mt: 1 }} variant="h4" fontWeight="700">
            <Grid item md={6} xs={12}>
              <Grid container spacing={2}>
                {/* <Grid
                  item
                  md={6}
                  xs={4}
                  display="flex"
                  justify="center"
                  alignItems="center"
                  columnSpacing={{ xs: 1 }}
                >
                  <div
                    style={
                      {
                        // display: "flex",
                        // flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        // margin: "15% 5% 0 0",
                      }
                    }
                  >
                    {imageUrl && imageUrl.length > 0 ? (
                      // eslint-disable-next-line jsx-a11y/img-redundant-alt
                      <img
                        alt="profile-image"
                        src={imageUrl}
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <InsertPhotoOutlined
                        fontSize="large"
                        color="disabled"
                        sx={{
                          height: "4.2em",
                          width: "6.2em",
                        }}
                      />
                    )}
                  </div>
                </Grid> */}
                <Grid item md={6} xs={6}>
                  <Typography color="textPrimary" variant="h4" sx={{ mt: 2 }}>
                    {performingOrg?.name}
                  </Typography>
                  <Typography variant="body2">
                    {performingOrg?.street_address?.address_line_1}
                  </Typography>
                  <Typography variant="body2">
                    {performingOrg?.street_address?.address_line_2}
                  </Typography>
                  <Typography variant="body2">
                    {performingOrg?.street_address?.city}
                    {performingOrg?.street_address?.state_or_province}
                  </Typography>
                  <Typography variant="body2">
                    {performingOrg?.street_address?.country_or_region}
                    {performingOrg?.street_address?.postal_code}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Typography>
          <Typography sx={{}} variant="h3" fontWeight="700">
            Detail Report
            <Typography variant="body2">{workItemId}</Typography>
          </Typography>
        </Stack>

        <Card sx={{ p: 1, mt: 2 }} variant="outlined">
          <Grid container spacing={2}>
            <Grid item md={6}>
              <Typography variant="h4">Prepare For</Typography>
              <Typography>{customer?.name} </Typography>
              <Typography>
                {/* Address 1:{" "} */}
                {customer ? customer?.street_address?.address_line_1 : ""}
              </Typography>
              <Typography>
                {customer ? customer?.street_address?.address_line_2 : ""}
              </Typography>
              <Typography>
                {customer
                  ? `${customer?.street_address?.city || ""}, ${
                      customer?.street_address?.state || ""
                    }, ${customer?.street_address?.postal_code || ""}`
                  : ""}
              </Typography>
            </Grid>
          </Grid>
        </Card>
        <Card sx={{ p: 1, my: 2 }} variant="outlined">
          <Stack direction="row">
            <Box sx={{ pr: 2 }}>
              <AssetImage asset={asset} />
            </Box>
            <Box>
              <Typography
                // sx={{ display: "inline" }}
                // component="span"
                variant="body1"
                color="text.primary"
                noWrap
                // sx={{ fontWeight: "inherit", flexGrow: 1 }}
              >
                {/* Asset ID: */}
                {asset.id || asset.system_id}
              </Typography>
              <Typography
                // sx={{ display: "inline" }}
                // component="span"
                variant=""
                color="text.secondary"
                noWrap
                // sx={{ fontWeight: "inherit", flexGrow: 1 }}
              >
                {/* Name: */}
                {asset.name}
                {/* Make: */}
                {asset.make}
                {/* Model: */}
                {asset.model} {/* Description: */}
                {asset.description}
              </Typography>
            </Box>
          </Stack>
        </Card>
        <Box>
          <Suspense>
            <WorkItem
              row={row}
              orgID={workItem?.performing_org}
              mode="REPORT_VIEW"
              report
            />
          </Suspense>
        </Box>
      </Container>
    </div>
  );
};

export { DetailReport };
